import { useState, useEffect } from "react";

/** Hover plus fine pointer means a computer, which cannot open store links, so it gets the QR. */
const QUERY = "(hover: hover) and (pointer: fine)";

const read = (): boolean | undefined =>
  typeof window !== "undefined" && typeof window.matchMedia === "function"
    ? window.matchMedia(QUERY).matches
    : undefined;

const usePrefersQr = (): boolean | undefined => {
  const [prefersQr, setPrefersQr] = useState(read);

  useEffect(() => {
    if (typeof window.matchMedia !== "function") return;
    const mql = window.matchMedia(QUERY);
    const onChange = () => setPrefersQr(mql.matches);
    onChange(); // the device may have changed between the first render and now
    // Safari before 14 only has the old addListener API.
    if (mql.addEventListener) {
      mql.addEventListener("change", onChange);
      return () => mql.removeEventListener("change", onChange);
    }
    mql.addListener?.(onChange);
    return () => mql.removeListener?.(onChange);
  }, []);

  return prefersQr;
};

export default usePrefersQr;
